<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { RouterView } from "vue-router";
import { useDeploymentToasts } from "./composables/useDeploymentToasts";
import { useAppStore } from "./stores/appStore";
import { useOperationalControlsStore } from "./stores/operationalControlsStore";

const { initialize, cleanup } = useDeploymentToasts();
const operationalControlsStore = useOperationalControlsStore();
const appStore = useAppStore();

onMounted(() => {
  initialize();
  operationalControlsStore.initialize();
  appStore.initializeVersionPolling();
});

onUnmounted(() => {
  cleanup();
  operationalControlsStore.cleanup();
  appStore.cleanupVersionPolling();
});
</script>

<template>
  <RouterView />
</template>
